"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxType = exports.ReceiptField = exports.TxField = exports.AccountField = exports.HeaderField = exports.DataSubqueryType = void 0;
var DataSubqueryType;
(function (DataSubqueryType) {
    DataSubqueryType[DataSubqueryType["StorageV1"] = 0] = "StorageV1";
    DataSubqueryType[DataSubqueryType["Header"] = 1] = "Header";
    DataSubqueryType[DataSubqueryType["Account"] = 2] = "Account";
    DataSubqueryType[DataSubqueryType["Storage"] = 3] = "Storage";
    DataSubqueryType[DataSubqueryType["Transaction"] = 4] = "Transaction";
    DataSubqueryType[DataSubqueryType["Receipt"] = 5] = "Receipt";
    DataSubqueryType[DataSubqueryType["SolidityNestedMapping"] = 6] = "SolidityNestedMapping";
    DataSubqueryType[DataSubqueryType["BeaconValidator"] = 7] = "BeaconValidator";
})(DataSubqueryType || (exports.DataSubqueryType = DataSubqueryType = {}));
var HeaderField;
(function (HeaderField) {
    HeaderField[HeaderField["ParentHash"] = 0] = "ParentHash";
    HeaderField[HeaderField["Sha3Uncles"] = 1] = "Sha3Uncles";
    HeaderField[HeaderField["Miner"] = 2] = "Miner";
    HeaderField[HeaderField["StateRoot"] = 3] = "StateRoot";
    HeaderField[HeaderField["TransactionsRoot"] = 4] = "TransactionsRoot";
    HeaderField[HeaderField["ReceiptsRoot"] = 5] = "ReceiptsRoot";
    HeaderField[HeaderField["LogsBloom"] = 6] = "LogsBloom";
    HeaderField[HeaderField["Difficulty"] = 7] = "Difficulty";
    HeaderField[HeaderField["Number"] = 8] = "Number";
    HeaderField[HeaderField["GasLimit"] = 9] = "GasLimit";
    HeaderField[HeaderField["GasUsed"] = 10] = "GasUsed";
    HeaderField[HeaderField["Timestamp"] = 11] = "Timestamp";
    HeaderField[HeaderField["ExtraData"] = 12] = "ExtraData";
    HeaderField[HeaderField["MixHash"] = 13] = "MixHash";
    HeaderField[HeaderField["Nonce"] = 14] = "Nonce";
    HeaderField[HeaderField["BaseFeePerGas"] = 15] = "BaseFeePerGas";
    HeaderField[HeaderField["WithdrawalsRoot"] = 16] = "WithdrawalsRoot";
    // BlobGasUsed, // EIP-4844
    // ExcessBlobGas, // EIP-4844
    // ParentBeaconBlockRoot, // EIP-4844
})(HeaderField || (exports.HeaderField = HeaderField = {}));
var AccountField;
(function (AccountField) {
    AccountField[AccountField["Nonce"] = 0] = "Nonce";
    AccountField[AccountField["Balance"] = 1] = "Balance";
    AccountField[AccountField["StorageRoot"] = 2] = "StorageRoot";
    AccountField[AccountField["CodeHash"] = 3] = "CodeHash";
})(AccountField || (exports.AccountField = AccountField = {}));
var TxField;
(function (TxField) {
    TxField[TxField["ChainId"] = 0] = "ChainId";
    TxField[TxField["Nonce"] = 1] = "Nonce";
    TxField[TxField["MaxPriorityFeePerGas"] = 2] = "MaxPriorityFeePerGas";
    TxField[TxField["MaxFeePerGas"] = 3] = "MaxFeePerGas";
    TxField[TxField["GasLimit"] = 4] = "GasLimit";
    TxField[TxField["To"] = 5] = "To";
    TxField[TxField["Value"] = 6] = "Value";
    TxField[TxField["Data"] = 7] = "Data";
    // AccessList is not supported
    TxField[TxField["GasPrice"] = 8] = "GasPrice";
    TxField[TxField["v"] = 9] = "v";
    TxField[TxField["r"] = 10] = "r";
    TxField[TxField["s"] = 11] = "s";
})(TxField || (exports.TxField = TxField = {}));
var ReceiptField;
(function (ReceiptField) {
    ReceiptField[ReceiptField["Status"] = 0] = "Status";
    ReceiptField[ReceiptField["PostState"] = 1] = "PostState";
    ReceiptField[ReceiptField["CumulativeGas"] = 2] = "CumulativeGas";
    ReceiptField[ReceiptField["LogsBloom"] = 3] = "LogsBloom";
    ReceiptField[ReceiptField["Logs"] = 4] = "Logs";
})(ReceiptField || (exports.ReceiptField = ReceiptField = {}));
var TxType;
(function (TxType) {
    TxType[TxType["Legacy"] = 0] = "Legacy";
    TxType[TxType["Eip2930"] = 1] = "Eip2930";
    TxType[TxType["Eip1559"] = 2] = "Eip1559";
    TxType[TxType["Eip4844"] = 3] = "Eip4844";
})(TxType || (exports.TxType = TxType = {}));
